import { queryClient } from '@/lib/queryClient'

import { QueryKeys } from '@/enums'

export const getCachedCommentsActivityIds = () => {
  const cachedCommentsQueriesData = queryClient.getQueriesData({
    queryKey: [QueryKeys.ActivityDetails],
  })
  const cachedCommentsActivityIds = []

  cachedCommentsQueriesData.forEach((commentQueryData) =>
    cachedCommentsActivityIds.push(commentQueryData[0][1])
  )

  return cachedCommentsActivityIds
}
